export enum UserTypes {
    ADMIN = "admin",
    CUSTOMER = "customer",
    EMPLOYEE = "employee",
}